import { render, staticRenderFns } from "./AppHistoryDataTable.vue?vue&type=template&id=07eedd10&scoped=true&"
import script from "./AppHistoryDataTable.vue?vue&type=script&lang=js&"
export * from "./AppHistoryDataTable.vue?vue&type=script&lang=js&"
import style0 from "./AppHistoryDataTable.vue?vue&type=style&index=0&id=07eedd10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07eedd10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VDataTable})
